import { SOCKET_URI } from "@/configs/env.config";
import { COOKIE_KEY } from "@/configs/global.config";
import useSocketStore from "@/stores/socket";
import Cookies from "js-cookie";
import _ from "lodash";
import { useEffect } from "react";
import { io } from "socket.io-client";
import useProfile from "./useProfile";

export const useGlobalSocket = () => {
  const { socket, setSocket, disconnectSocket, addMessage, setRooms } = useSocketStore();
  const profile = useProfile();

  useEffect(() => {
    if (socket || !profile) {
      return;
    }

    const token = Cookies.get(COOKIE_KEY.ACCESS_TOKEN);
    const newSocket = io(SOCKET_URI, {
      transports: ["websocket"],
      query: { token },
    });

    setSocket(newSocket);

    const interval = setInterval(() => {
      newSocket.emit("ping");
    }, 20 * 1000);

    newSocket.on("message", (data: any) => {
      const { focusRoom } = useSocketStore.getState();
      if (focusRoom && data?.roomId === focusRoom?.id) {
        addMessage(data);
      }
    });

    newSocket.on("chatRoomsList", (data: any[]) => {
      const { listRoom } = useSocketStore.getState();
      setRooms(
        data?.map((newRoom) => {
          const oldRoom = _.find(listRoom, { roomId: newRoom.roomId });
          return _.merge({}, oldRoom, newRoom);
        })
      );
    });

    return () => {
      if (interval) {
        clearInterval(interval);
      }
      disconnectSocket();
    };
  }, [profile]);
};
